// extracted by mini-css-extract-plugin
export default {"title":"TopSection_title__6A2wZ","dateAssignee":"TopSection_dateAssignee__tekFu"};